import { FC } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Button, LevelNumberBadge, LottieAnimation, Modal } from 'src/components';
import { defaultAnimationOptions } from 'src/components/constants';
import levelUpAnimation from '../assets/level-up-animation.json';
import soundFile from '../assets/level-up-celebration.mp3';
import * as S from './styles';

const msgs = defineMessages({
  header: {
    id: 'eos_levelUp_celebration_title',
  },
  points: {
    id: 'eos_levelUp_celebration_pointsReached_web',
  },
  level: {
    id: 'eos_levelUp_celebration_levelReached_web',
  },
  continue: {
    id: 'Continue',
  },
});

export const LevelUpCelebration: FC<{
  level: number;
  points: number;
  languageName: string;
  onClickContinue: () => void;
  isOpen: boolean;
}> = ({ level, points, languageName, onClickContinue, isOpen }) => {
  const intl = useIntl();

  return (
    <Modal isOpen={isOpen} fullSize hideCloseButton>
      {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
      <audio autoPlay preload="auto" src={soundFile} data-testid="level-up-sound" />

      <S.ModalContent>
        <S.Header>{intl.formatMessage(msgs.header)}</S.Header>
        <S.Description>
          {intl.formatMessage(msgs.points, {
            points,
          })}
        </S.Description>
        <S.LevelWrapper>
          <S.LevelNumber>
            <LevelNumberBadge level={level} state="in-progress" size="xl" />
          </S.LevelNumber>
          <S.AnimationContainer data-testid="level-up-animation">
            <LottieAnimation {...defaultAnimationOptions} animationData={levelUpAnimation} loop />
          </S.AnimationContainer>
        </S.LevelWrapper>
        <S.Language>{languageName}</S.Language>
        <S.Level>
          {intl.formatMessage(msgs.level, {
            level,
          })}
        </S.Level>
        <Button buttonSize="medium" buttonType="primary" onClick={onClickContinue}>
          {intl.formatMessage(msgs.continue)}
        </Button>
      </S.ModalContent>
    </Modal>
  );
};
